const React = require('react')

import {
  Button,
  ButtonGroup,
  Glyphicon,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap'
const basePath = window.basePath || '';

export default class FrogMakerTemplateKeywordFilter extends React.Component {
  render() {
    const tooltipText = `Click here to download FrogMaker Sites/Templates)`

    return (
      <div className="navbar-left vcentered-parent">
        <ul className="nav nav-pills">
          <li>
            <OverlayTrigger 
              placement="bottom"
              overlay={<Tooltip id={`tooltip-${this.props.keywordId}`}>{tooltipText}</Tooltip>}
            >
              <ButtonGroup>
                <Button href={`${basePath}/sites?keyword=${this.props.keywordId}`} bsStyle={!this.props.isSelected ? "link" : "primary"}>
                    {this.props.children}
                </Button>
                {this.props.isSelected &&
                <Button style={{display: "inline"}} bsStyle="danger" onClick={this.props.onKeywordClear}>
                  <Glyphicon glyph="remove" />
                </Button>
                }
              </ButtonGroup>
            </OverlayTrigger>
          </li>
        </ul>
      </div>
    )
  }
}